/* ============================================
   QUOTE WORKSTATION — Product Search & Catalog
   Asset: workstation-search.js
   Catalog loading, instant search, product click
   handling, and search UI management.
   ============================================ */
(function() {
  'use strict';
  var Q = window.QWS;
  if (!Q) return;

  var state = Q.state;
  var dom = Q.dom;
  var wrap = Q.wrap;
  var API = Q.API;
  var escHtml = Q.escHtml;
  var escAttr = Q.escAttr;
  var fmt = Q.fmt;
  var autoPoints = Q.autoPoints;

  /* ── Product Catalog (pre-loaded for instant search) ── */
  var catalog = null; // full product array from /product-catalog
  var catalogLoading = false;
  var catalogReady = false;
  var catalogFailed = false;
  var catalogLoadedAt = 0;   // CUSTOM_ECORE2027_BY_CLAUDE — see the visibilitychange hook below loadCatalog()

  // Build a search index string for each product (title + vendor + all variant SKUs)
  function buildSearchIndex(products) {
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      var parts = [p.t, p.v]; // title, vendor
      var vs = p.vs || [];
      for (var j = 0; j < vs.length; j++) {
        if (vs[j].sk) parts.push(vs[j].sk);
      }
      p._idx = parts.join(' ').toLowerCase();
    }
  }

  var catalogRetries = 0;

  /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-11) — animated ellipsis on the
     rebuilding placeholder (. → .. → ... → repeat) so the wait reads as alive
     rather than hung. Stopped on every exit from the building state. */
  var rebuildDotsTimer = null;
  function startRebuildDots(baseText) {
    stopRebuildDots();
    var n = 1;
    dom.searchInput.setAttribute('placeholder', baseText + '.');
    rebuildDotsTimer = setInterval(function() {
      n = (n % 3) + 1;
      dom.searchInput.setAttribute('placeholder', baseText + '...'.slice(0, n));
    }, 500);
  }
  function stopRebuildDots() {
    if (rebuildDotsTimer) { clearInterval(rebuildDotsTimer); rebuildDotsTimer = null; }
  }
  /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

  function loadCatalog() {
    if (catalogLoading || catalogReady) return;
    catalogLoading = true;
    catalogRetries++;
    stopRebuildDots();
    dom.searchInput.setAttribute('placeholder', catalogRetries > 1 ? 'Retrying catalog load...' : 'Loading product catalog...');

    API.get('/product-catalog').then(function(data) {
      // Catalog is being rebuilt by another request — wait and retry
      if (data.building) {
        catalogLoading = false;
        startRebuildDots('Product catalog is rebuilding — please wait');
        setTimeout(function() { catalogRetries--; loadCatalog(); }, 10000);
        return;
      }
      stopRebuildDots();
      catalog = data.products || [];
      Q.catalog = catalog;
      /* CUSTOM_QWOPTIONS_BY_CLAUDE (Ryan 2026-08-24) — handle -> compact catalog entry.
         renderItems() now asks, for EVERY line on every re-render, "does this product have
         configurable options, and is this sub-text row one of their real values?" — which was an
         Array.find over ~7,000 entries per row per keystroke. Built once here instead. */
      catalogByHandle = {};
      for (var _ci = 0; _ci < catalog.length; _ci++) {
        if (catalog[_ci] && catalog[_ci].h) catalogByHandle[catalog[_ci].h] = catalog[_ci];
      }
      Q.catalogByHandle = catalogByHandle;
      buildSearchIndex(catalog);
      catalogReady = true;
      Q.catalogReady = true;
      catalogLoading = false;
      catalogFailed = false;
      /* CUSTOM_QWOPTIONLABEL_BY_CLAUDE (Ryan 2026-10-10) — lines drawn before the catalogue arrived have no
         Options button and no labelled colour line (both read the catalogue). Draw them again now. */
      if (state.items && state.items.length && Q.renderItems) { try { Q.renderItems(); } catch (_e) {} }
      /* CUSTOM_FREIGHTCHANGERULE_BY_CLAUDE - an added product counts against quoted freight only when the catalogue tags it
         freight-quoted, so ask again once the catalogue is here. */
      if (Q.checkFreightStaleness) { try { Q.checkFreightStaleness(); } catch (_e) {} }
      catalogLoadedAt = Date.now();
      dom.searchInput.setAttribute('placeholder', 'Search by name, SKU, or vendor (' + catalog.length + ' products)');
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-11) — admin-only staleness
         banner. The catalog KV entry no longer expires (a failed nightly
         rebuild used to DELETE it → empty search all day), so reps always
         keep a working catalog. data.rebuiltAt = last FULL rebuild (webhook
         patches bump ts but not rebuiltAt). Older than 30h = the 9:15 UTC
         cron missed at least one run — search still works on stale data,
         flag it for admin so it gets looked at instead of silently rotting. */
      var _rebuiltAt = data.rebuiltAt || data.ts || 0;
      /* CUSTOM_QWALERTS_BY_CLAUDE (Ryan 2026-10-23, Pass 2) - a row in the page's alerts banner, not a box under the search. */
      if (Q.isAdmin && _rebuiltAt && (Date.now() - _rebuiltAt) > 30 * 3600 * 1000 && Q.showAlert) {
        Q.showAlert({ id: 'catalog-stale', level: 'yellow', icon: '&#x1F5C2;&#xFE0F;', sig: String(_rebuiltAt),
          head: 'Catalog is stale',
          text: 'Last full rebuild was ' + ((Date.now() - _rebuiltAt) / 86400000).toFixed(1) + ' days ago, so the nightly rebuild may be failing. Search still works, but newer products or prices may be missing. (Admins only.)' });
      } else if (Q.isAdmin && _rebuiltAt && (Date.now() - _rebuiltAt) > 30 * 3600 * 1000 && !document.querySelector('.rq-ws-catalog-stale')) {
        var _staleDays = ((Date.now() - _rebuiltAt) / 86400000).toFixed(1);
        var _staleNote = document.createElement('div');
        _staleNote.className = 'rq-ws-catalog-stale';
        _staleNote.setAttribute('style', 'margin:6px 0 0;padding:8px 10px;border:1px solid #F59E0B;background:rgba(245,158,11,0.10);color:#B45309;border-radius:8px;font-size:12px;line-height:1.4;');
        _staleNote.innerHTML = '&#9888;&#65039; <strong>Catalog is stale</strong> — last full rebuild was ' + _staleDays
          + ' days ago, so the nightly rebuild may be failing. Search still works, but products/pricing changed since then may be missing. (Admin-only notice — worth a Claude dive into rfq-worker’s 9:15 UTC cron.)';
        dom.searchInput.insertAdjacentElement('afterend', _staleNote);
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      var q = dom.searchInput.value.trim();
      if (q.length >= 1) doSearch(q);
    }).catch(function() {
      catalogLoading = false;
      catalogFailed = true;
      stopRebuildDots();
      // Auto-retry up to 8 times with increasing delay (catalog rebuild can take minutes)
      if (catalogRetries < 8) {
        dom.searchInput.setAttribute('placeholder', 'Catalog load failed — retrying (' + catalogRetries + '/8)...');
        setTimeout(loadCatalog, 5000 * Math.min(catalogRetries, 4));
      } else {
        dom.searchInput.setAttribute('placeholder', 'Catalog unavailable — refresh page to retry');
      }
    });
  }

  // Start loading catalog as soon as the page renders
  loadCatalog();

  /* CUSTOM_ECORE2027_BY_CLAUDE (Ryan 2026-09-29) — THE CATALOG WAS READ ONCE PER PAGE LOAD AND NEVER
     AGAIN. A Workstation tab left open across a vendor price change (Ecore, 10/1) kept adding NEW
     lines at the old price for as long as the tab lived, with nothing on screen to say so. When the
     tab comes back into view after 20+ minutes away, re-read the catalog and drop the per-session
     variant cache; lines already on the quote are untouched (their price is the quote's). */
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState !== 'visible' || !catalogReady || catalogLoading) return;
    if (Date.now() - catalogLoadedAt < 20 * 60 * 1000) return;
    catalogReady = false; Q.catalogReady = false; catalogRetries = 0; variantCache = {};
    loadCatalog();
  });

  // Normalize a catalog product to the shape handleProductClick expects
  // For single-variant products, includes full variant data
  // For multi-variant products, only has options + count (variants fetched on click)
  function normProduct(cp) {
    var product = {
      title: cp.t,
      handle: cp.h,
      vendor: cp.v,
      options: (cp.o || []).map(function(o) { return { name: o.n, values: o.v }; }),
      variantCount: cp.vc || 0,
      firstPrice: cp.fp || '0',
      firstSku: cp.fk || '',
      firstCost: cp.fc || null,
      firstCompareAtPrice: cp.fcp || null,
      uom: cp.uom || null,
    };
    if (cp.co) {
      product.customOptions = cp.co.map(function(co) { return { label: co.l, type: co.t, values: co.v }; });
    }
    if (cp.vs) {
      product.variants = cp.vs.map(function(va) {
        var vid = va.id;
        if (vid && vid.indexOf('gid://') === -1) vid = 'gid://shopify/ProductVariant/' + vid;
        return {
          id: vid,
          title: va.t || 'Default Title',
          price: va.p,
          compareAtPrice: va.cp || null,
          sku: va.sk || '',
          available: true,
          cost: va.c || null,
          selectedOptions: va.so ? va.so.map(function(so) { return { name: so.n, value: so.v }; }) : []
        };
      });
    }
    return product;
  }

  // Fetch full variant data for a product (used when clicking multi-variant products or fixing variant mismatch)
  var catalogByHandle = {}; // { handle: compact catalog entry } — see loadCatalog
  var variantCache = {}; // { handle: product }
  function fetchProductVariants(product) {
    if (variantCache[product.handle]) {
      return Promise.resolve(variantCache[product.handle]);
    }
    return API.get('/product-by-handle?handle=' + encodeURIComponent(product.handle)).then(function(data) {
      var match = data.product;
      if (match) {
        match.vendor = match.vendor || product.vendor;
        variantCache[product.handle] = match;
      }
      return match;
    });
  }

  /* ── Product Search (instant client-side filtering) ── */
  var searchTimer = null;

  dom.searchInput.addEventListener('input', function() {
    if (searchClosing) return;
    var q = this.value.trim();
    clearTimeout(searchTimer);
    if (q.length < 1) { closeSearch(); return; }
    if (catalogReady) {
      searchTimer = setTimeout(function() { doSearch(q); }, 30);
    } else {
      dom.searchResults.innerHTML = '<div class="rq-ws-search-loading">Loading product catalog...</div>';
      showSearchDropdown();
    }
  });

  var searchHighlightIdx = -1;

  dom.searchInput.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') { closeSearch(); return; }
    var items = dom.searchResults.querySelectorAll('.rq-ws-search-item');
    if (!items.length) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      searchHighlightIdx = Math.min(searchHighlightIdx + 1, items.length - 1);
      items.forEach(function(el, i) { el.classList.toggle('rq-ws-search-item--highlight', i === searchHighlightIdx); });
      items[searchHighlightIdx].scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      searchHighlightIdx = Math.max(searchHighlightIdx - 1, 0);
      items.forEach(function(el, i) { el.classList.toggle('rq-ws-search-item--highlight', i === searchHighlightIdx); });
      items[searchHighlightIdx].scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (searchHighlightIdx >= 0 && searchHighlightIdx < items.length) {
        items[searchHighlightIdx].click();
      }
    }
  });

  function doSearch(q) {
    if (!catalogReady) {
      dom.searchResults.innerHTML = '<div class="rq-ws-search-loading">Loading product catalog...</div>';
      showSearchDropdown();
      return;
    }

    var qLower = q.toLowerCase();
    var terms = qLower.split(/\s+/).filter(function(t) { return t.length > 0; });
    if (!terms.length) { closeSearch(); return; }

    var matches = [];
    for (var i = 0; i < catalog.length && matches.length < 30; i++) {
      var p = catalog[i];
      var allMatch = true;
      for (var ti = 0; ti < terms.length; ti++) {
        if (p._idx.indexOf(terms[ti]) === -1) { allMatch = false; break; }
      }
      if (allMatch) matches.push(p);
    }

    renderSearchResults(matches);
  }

  function renderSearchResults(products) {
    searchHighlightIdx = -1;
    showSearchDropdown();
    if (!products.length) {
      dom.searchResults.innerHTML = '<div class="rq-ws-search-empty">No products found</div>';
      return;
    }
    var html = '';
    var normalized = [];
    products.forEach(function(raw, idx) {
      var p = normProduct(raw);
      normalized.push(p);
      var price = p.firstPrice || (p.variants && p.variants.length ? p.variants[0].price : '');
      var vendor = p.vendor || '';
      var variantCount = p.variantCount || (p.variants ? p.variants.length : 0);
      var sku = p.firstSku || (p.variants && p.variants.length === 1 && p.variants[0].sku ? p.variants[0].sku : '');
      html += '<div class="rq-ws-search-item" data-product-idx="' + idx + '">';
      html += '<div class="rq-ws-search-item__info">';
      html += '<div class="rq-ws-search-item__title">' + escHtml(p.title) + '</div>';
      html += '</div>';
      if (price) html += '<div class="rq-ws-search-item__price">' + fmt(parseFloat(price)) + '</div>';
      html += '</div>';
    });
    dom.searchResults.innerHTML = html;
    dom.searchResults._products = normalized;

    var items = dom.searchResults.querySelectorAll('.rq-ws-search-item');
    items.forEach(function(el) {
      el.addEventListener('click', function() {
        if (searchAddLock) return;
        var pidx = parseInt(this.getAttribute('data-product-idx'));
        var product = dom.searchResults._products[pidx];
        handleProductClick(product, pidx);
      });
    });
  }

  var searchBackdrop = wrap.querySelector('.rq-ws-search-backdrop');

  function showSearchDropdown() {
    dom.searchResults.classList.add('rq-ws-search-bar__results--open');
    if (searchBackdrop) searchBackdrop.classList.add('rq-ws-search-backdrop--open');
  }

  var searchClosing = false;
  function closeSearch() {
    searchClosing = true;
    dom.searchInput.value = '';
    dom.searchResults.classList.remove('rq-ws-search-bar__results--open');
    dom.searchResults.innerHTML = '';
    if (searchBackdrop) searchBackdrop.classList.remove('rq-ws-search-backdrop--open');
    searchAddLock = false;
    setTimeout(function() { searchClosing = false; }, 50);
  }

  // Close search when clicking backdrop
  if (searchBackdrop) {
    searchBackdrop.addEventListener('click', function() {
      dom.searchInput.value = '';
      closeSearch();
      // Also close any open inline config pickers
      var openPickers = dom.itemsContainer.querySelectorAll('.rq-ws-inline-picker');
      for (var pi = 0; pi < openPickers.length; pi++) openPickers[pi].remove();
      // Reset vendor group z-indexes
      dom.itemsContainer.querySelectorAll('.rq-ws-vendor-group').forEach(function(g) { g.style.zIndex = ''; });
      searchBackdrop.classList.remove('rq-ws-search-backdrop--open');
    });
  }

  // Strip vendor/brand name from beginning of product title (it's in the vendor group header already)
  function stripVendor(title, vendor) {
    if (!vendor || !title) return title;
    if (title.toLowerCase().indexOf(vendor.toLowerCase()) === 0) {
      var stripped = title.substring(vendor.length).replace(/^[\s\-–—:]+/, '').trim();
      return stripped || title;
    }
    return title;
  }

  /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-14) — Quote-name overrides.
     A few product titles are written long for SEO ("ECORE Straight Edge Reducer,
     3/4" x 48" Rubber Transition Strip") and read badly as a quote line. Keyed by
     product handle: `name` replaces the line title, `sub` is a default
     sub-description the rep can still edit or delete.
     Write `name` WITH the vendor prefix — it goes through stripVendor like every
     other title, so the prefix drops under a vendor group header and survives
     anywhere that header isn't there. */
  var QUOTE_OVERRIDES = {
    'ecore-straight-edge-reducer-rubber-floor-transition-strip': {
      name: 'ECORE Straight Edge Reducer',
      sub: '3/4" x 48" Rubber Transition Strip'
    }
  };

  function quoteOverride(product) {
    if (!product || !product.handle) return null;
    return QUOTE_OVERRIDES[product.handle] || null;
  }

  // The title a quote line should carry: the override name when one exists, else
  // the catalog title — always through stripVendor so the vendor rule still runs.
  function quoteTitle(product) {
    var ov = quoteOverride(product);
    return stripVendor((ov && ov.name) || product.title, product.vendor);
  }

  // Every add path funnels its sub-descriptions through here: UOM label first,
  // then the override's default descriptor line above it.
  function defaultSubDescs(subDescs, product) {
    var out = maybeAddUOMLabel(subDescs || [], product);
    var ov = quoteOverride(product);
    if (!ov || !ov.sub) return out;
    var already = out.some(function(s) { return (s.value || s || '') === ov.sub; });
    return already ? out : [ov.sub].concat(out);
  }
  /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

  // Extract a model number from title if SKU is empty
  // Looks for standalone 3-6 digit numbers (e.g., "LeverEDGE 6001 Shoulder Press" → model "6001")
  function extractModel(title, existingSku) {
    if (existingSku) return { title: stripModelFromTitle(title, existingSku), sku: existingSku };
    var match = title.match(/\b(\d{3,6})\b/);
    if (match) {
      var model = match[1];
      var clean = title.replace(match[0], '').replace(/\s{2,}/g, ' ').replace(/^[\s\-–—]+/, '').trim();
      return { title: clean, sku: model };
    }
    return { title: title, sku: '' };
  }

  // Strip SKU/model from title if it appears as a standalone token
  // e.g., "3100 Utility Flat Bench" + sku "3100" → "Utility Flat Bench"
  // e.g., "3142-FT Half Cage" + sku "3142-FT" → "Half Cage"
  // Only strips if title contains the SKU as-is; leaves title alone if different
  function stripModelFromTitle(title, sku) {
    if (!sku || !title) return title;
    var escaped = sku.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var re = new RegExp('\\b' + escaped + '\\b[\\s\\-–—:]*', 'i');
    var stripped = title.replace(re, '').replace(/\s{2,}/g, ' ').trim();
    return stripped || title;
  }

  /* ── Normalize options from API ── */
  // API returns values as objects [{name, swatch}] — normalize to string arrays
  // and build a swatch lookup map for rendering
  // Options from API now include: { name, values: [strings], swatches: { valueName: {color, image} } }
  // This function is a no-op pass-through but kept for safety with older cached data
  function normalizeOptions(options) {
    return options.map(function(opt) {
      var swatches = {};
      var values = (opt.values || []).map(function(v) {
        if (typeof v === 'object') {
          var name = v.name || v.value || String(v);
          if (v.swatch) swatches[name] = v.swatch;
          return name;
        }
        return v;
      });
      var result = { name: opt.name, values: values };
      if (Object.keys(swatches).length) result.swatches = swatches;
      return result;
    });
  }

  /* ── UOM Label ── */
  // UOM tag → display label mapping (matches price.liquid tags: unit:sqft, unit:tile, unit:paver)
  var UOM_LABELS = { sqft: 'sq ft', tile: 'tiles', paver: 'pavers', plank: 'planks', roll: 'rolls' };

  // Prepend "Quoted as {unit}" to sub-descriptions if the product has a UOM tag
  // Matches the format the Gym Layout Designer uses on export
  function maybeAddUOMLabel(subDescs, product) {
    var uom = product && product.uom;
    if (!uom) return subDescs;
    var label = UOM_LABELS[uom];
    if (!label) return subDescs;
    // Don't duplicate if already present (e.g., designer export)
    var already = subDescs.some(function(s) { return (s.value || s || '').indexOf('Quoted as') === 0; });
    if (already) return subDescs;
    return ['Quoted as ' + label].concat(subDescs);
  }

  var searchAddLock = false;

  function handleProductClick(product, pidx) {
    if (searchAddLock) return;
    // Remove existing variant picker
    var existing = dom.searchResults.querySelector('.rq-ws-variant-picker');
    if (existing) existing.remove();

    var variants = product.variants || [];
    var options = normalizeOptions(product.options || []);

    // Single variant — add directly
    if (variants.length === 1) {
      var v = variants[0];
      var svTitle = quoteTitle(product);
      var em = extractModel(svTitle, v.sku);
      var svSubDescs = [];
      if (v.title && v.title !== 'Default Title') {
        // Build sub-descriptions from selected options if available, otherwise use variant title
        var so = v.selectedOptions || [];
        if (so.length > 0) {
          so.forEach(function(opt) { svSubDescs.push(opt.name + ': ' + opt.value); });
        } else {
          svSubDescs.push(v.title);
        }
      }
      svSubDescs = defaultSubDescs(svSubDescs, product);
      var svCost = parseFloat(v.cost) || parseFloat(product.firstCost) || 0;
      var svMap = parseFloat(v.price) || 0;
      var svItem = {
        type: 'product',
        variantId: v.id,
        vendor: product.vendor || '',
        title: em.title,
        sku: em.sku,
        quantity: 1,
        msrp: parseFloat(v.compareAtPrice) || Q.findCompareAtPrice(variants, product),
        cost: svCost,
        mapPrice: svMap,
        subDescriptions: svSubDescs
      };
      if (svCost > 0 && svMap > 0) {
        svItem.points = autoPoints(svCost, svMap);
        svItem.directPrice = svMap;
      }
      Q.addItem(svItem);
      dom.searchInput.value = '';
      closeSearch();
      return;
    }

    // Check vendor preferences against catalog options (works without variant data)
    var resolvedOpts = {};
    var prefResolved = {};
    var unresolvedCount = 0;

    if (options.length > 0) {
      options.forEach(function(opt, oi) {
        var pref = Q.getPref(product.vendor, opt.name, opt.values);
        if (pref) {
          resolvedOpts[oi] = pref;
          prefResolved[oi] = true;
        } else {
          unresolvedCount++;
        }
      });

      // Check if variants have unique SKUs (flooring, Airex, etc.)
      var uniqueSKUs = Q.variantsHaveUniqueSKUs(variants);

      // All options resolved by preferences → auto-add (unless SKUs vary by variant)
      if (unresolvedCount === 0) {
        // Unique SKUs: show picker with prefs pre-selected so rep confirms the right color/SKU
        if (uniqueSKUs) {
          var pickerEl = Q.buildVariantPicker(product, pidx, resolvedOpts, prefResolved);
          var clickedRow = dom.searchResults.querySelector('[data-product-idx="' + pidx + '"]');
          if (clickedRow) {
            clickedRow.insertAdjacentElement('afterend', pickerEl);
          } else {
            dom.searchResults.appendChild(pickerEl);
          }
          return;
        }

        // If we have variant data, find the exact matching variant
        if (variants.length > 0) {
          var optNames = options.map(function(o) { return o.name; });
          var matched = Q.findMatchingVariant(variants, optNames, resolvedOpts);
          if (matched) {
            var subDescs = Q.buildPrefSubDescs(options, prefResolved, resolvedOpts);
            subDescs = defaultSubDescs(subDescs, product);
            var builtTitle = Q.buildItemTitle(product, options, resolvedOpts, prefResolved);
            var em2 = extractModel(builtTitle, matched.sku);
            var mCost = parseFloat(matched.cost) || parseFloat(product.firstCost) || 0;
            var mMap = parseFloat(matched.price) || 0;
            var mItem = {
              type: 'product',
              variantId: matched.id,
              vendor: product.vendor || '',
              title: em2.title,
              sku: em2.sku,
              quantity: 1,
              msrp: parseFloat(matched.compareAtPrice) || Q.findCompareAtPrice(variants, product),
              cost: mCost,
              mapPrice: mMap,
              subDescriptions: subDescs
            };
            if (mCost > 0 && mMap > 0) {
              mItem.points = autoPoints(mCost, mMap);
              mItem.directPrice = mMap;
            }
            Q.addItem(mItem);
            dom.searchInput.value = '';
            closeSearch();
            Q.autoConfigureByPreferences();
            return;
          }
        }
        // No variant data or no match — add with pref sub-descs + catalog pricing (no fetch needed)
        var prefTitle = quoteTitle(product);
        var prefEm = extractModel(prefTitle, product.firstSku || '');
        var prefPrice = parseFloat(product.firstPrice) || 0;
        var prefCost = parseFloat(product.firstCost) || 0;
        Q.addItem({
          type: 'product',
          variantId: null,
          configured: true,
          vendor: product.vendor || '',
          title: prefEm.title,
          sku: prefEm.sku,
          quantity: 1,
          msrp: Q.findCompareAtPrice([], product),
          cost: prefCost,
          mapPrice: prefPrice,
          productHandle: product.handle,
          subDescriptions: defaultSubDescs(Q.buildPrefSubDescs(options, prefResolved, resolvedOpts), product)
        });
        dom.searchInput.value = '';
        closeSearch();
        Q.autoConfigureByPreferences();
        return;
      }

      // Some unresolved — show picker if SKUs vary, otherwise TBD add
      if (uniqueSKUs) {
        var pickerEl2 = Q.buildVariantPicker(product, pidx, resolvedOpts, prefResolved);
        var clickedRow2 = dom.searchResults.querySelector('[data-product-idx="' + pidx + '"]');
        if (clickedRow2) {
          clickedRow2.insertAdjacentElement('afterend', pickerEl2);
        } else {
          dom.searchResults.appendChild(pickerEl2);
        }
        return;
      }

      // Some unresolved — TBD add with catalog pricing (no fetch needed)
      var dTitle = quoteTitle(product);
      var firstV = variants[0] || {};
      var dEm = extractModel(dTitle, firstV.sku || product.firstSku || '');
      var tbdSubDescs = [];
      options.forEach(function(opt, oi) {
        if (prefResolved[oi]) {
          tbdSubDescs.push(opt.name + ': ' + resolvedOpts[oi]);
        } else {
          tbdSubDescs.push(opt.name + ': TBD');
        }
      });
      Q.addItem({
        type: 'product',
        variantId: firstV.id || null,
        configured: true,
        vendor: product.vendor || '',
        title: dEm.title,
        sku: dEm.sku,
        quantity: 1,
        msrp: parseFloat(firstV.compareAtPrice) || Q.findCompareAtPrice(variants, product),
        cost: parseFloat(firstV.cost) || parseFloat(product.firstCost) || 0,
        mapPrice: parseFloat(firstV.price) || parseFloat(product.firstPrice) || 0,
        productHandle: product.handle,
        subDescriptions: defaultSubDescs(tbdSubDescs, product)
      });
      dom.searchInput.value = '';
      closeSearch();
      return;
    }

    // No options — multi-variant without option data, need full variant data from API
    if (!variants.length && product.variantCount > 1) {
      searchAddLock = true;
      Q.searchAddLock = true;
      var clickedItem = dom.searchResults.querySelector('[data-product-idx="' + pidx + '"]');
      if (clickedItem) {
        clickedItem.style.opacity = '0.5';
        clickedItem.style.pointerEvents = 'none';
        var meta = clickedItem.querySelector('.rq-ws-search-item__meta');
        if (meta) meta.dataset.origText = meta.textContent, meta.textContent = 'Loading variants…';
      }

      fetchProductVariants(product).then(function(fullProduct) {
        searchAddLock = false;
        Q.searchAddLock = false;
        if (clickedItem) { clickedItem.style.opacity = ''; clickedItem.style.pointerEvents = ''; }
        if (!fullProduct) {
          dom.searchResults.innerHTML = '<div class="rq-ws-search-empty">Failed to load product details</div>';
          return;
        }
        dom.searchResults._products[pidx] = fullProduct;
        handleProductClick(fullProduct, pidx);
      }).catch(function() {
        searchAddLock = false;
        Q.searchAddLock = false;
        if (clickedItem) { clickedItem.style.opacity = ''; clickedItem.style.pointerEvents = ''; }
      });
      return;
    }

    // Fallback: add with catalog data
    var fbTitle = quoteTitle(product);
    var fbEm = extractModel(fbTitle, product.firstSku || '');
    var fbPrice = parseFloat(product.firstPrice) || 0;
    var fbSubDescs = defaultSubDescs([], product);
    Q.addItem({
      type: 'product',
      variantId: null,
      configured: true,
      vendor: product.vendor || '',
      title: fbEm.title,
      sku: fbEm.sku,
      quantity: 1,
      msrp: Q.findCompareAtPrice([], product),
      cost: parseFloat(product.firstCost) || 0,
      mapPrice: fbPrice,
      productHandle: product.handle,
      subDescriptions: fbSubDescs.length ? fbSubDescs : undefined
    });
    dom.searchInput.value = '';
    closeSearch();
  }

  /* ── SKU auto-resolve: rep edits SKU in-place, swap to matching variant ──
     Triggered from workstation-table.js on the SKU input event (debounced).
     When the typed SKU matches a sibling variant in the same product, we swap
     variantId/cost/mapPrice/msrp so the PDF and the Shopify checkout link both
     reflect the new variant. We don't touch subDescriptions — those may carry
     rep-authored notes ("1 roll @ 40' cut into 4 x 10' sections"). */
  var skuResolveTimers = {};
  function scheduleSkuResolve(itemId, sku) {
    if (skuResolveTimers[itemId]) clearTimeout(skuResolveTimers[itemId]);
    skuResolveTimers[itemId] = setTimeout(function() {
      delete skuResolveTimers[itemId];
      resolveSkuToVariant(itemId, sku);
    }, 600);
  }
  function applySkuVariantSwap(item, variant) {
    var newGid = variant.id && variant.id.indexOf('gid://') === 0
      ? variant.id
      : ('gid://shopify/ProductVariant/' + variant.id);
    if (item.variantId === newGid) return;
    item.variantId = newGid;
    // mapPrice and msrp are variant-driven (storefront price + compareAtPrice)
    // so safe to refresh from the new variant. Cost is preserved — the rep
    // may have manually negotiated it down, and a swap shouldn't blow that
    // away. Only fill cost if the item didn't have one yet.
    if (variant.price > 0) item.mapPrice = parseFloat(variant.price);
    if (variant.compareAtPrice > 0) item.msrp = parseFloat(variant.compareAtPrice);
    if (!(item.cost > 0) && variant.cost > 0) item.cost = parseFloat(variant.cost);
    if (item.cost > 0 && item.points > 0) {
      item.directPrice = Q.calculateDirect(item.cost, item.points);
    } else if (item.cost > 0 && item.mapPrice > 0) {
      item.points = autoPoints(item.cost, item.mapPrice);
      item.directPrice = item.mapPrice;
    }
    state.dirty = true;
    Q.recalcTotals();
    Q.renderItems();
    if (Q.showToast) Q.showToast('Variant updated to ' + (variant.title || variant.sku || 'new SKU'), 'success');
  }
  function resolveSkuToVariant(itemId, newSku) {
    var item = Q.findItem(itemId);
    if (!item || !item.productHandle) return;
    newSku = (newSku || '').trim();
    if (!newSku) return;
    var prod = (Q.catalog || []).find(function(p) { return p.h === item.productHandle; });
    if (!prod) return; // product not in catalog snapshot — silent no-op
    // Inline catalog variants (catalogs of products with <=50 variants)
    var inline = (prod.vs || []).find(function(v) { return v.sk === newSku; });
    if (inline) {
      applySkuVariantSwap(item, {
        id: inline.id,
        sku: inline.sk,
        price: parseFloat(inline.p) || 0,
        compareAtPrice: parseFloat(inline.cp) || 0,
        cost: parseFloat(inline.c) || 0,
        title: inline.t || '',
      });
      return;
    }
    // 51+ variant products or stale snapshot — fetch fresh
    Q.fetchProductVariants(prod).then(function(fresh) {
      if (!fresh || !fresh.variants) return;
      var v = fresh.variants.find(function(x) { return x.sku === newSku; });
      if (v) applySkuVariantSwap(item, v);
      // No match — silent. The rep might still be typing; debounce handles
      // partial input. If they tab/save without a match, the variantId stays
      // and the save handler still produces the right Shopify line item for
      // the existing variant.
    }).catch(function() {});
  }

  // Register on namespace for cross-module access
  Q.catalog = catalog;
  Q.catalogByHandle = catalogByHandle;
  Q.catalogReady = catalogReady;
  Q.variantCache = variantCache;
  Q.fetchProductVariants = fetchProductVariants;
  Q.scheduleSkuResolve = scheduleSkuResolve;
  Q.normProduct = normProduct;
  Q.normalizeOptions = normalizeOptions;
  Q.closeSearch = closeSearch;
  Q.searchAddLock = searchAddLock;
  Q.stripVendor = stripVendor;
  Q.extractModel = extractModel;
  Q.stripModelFromTitle = stripModelFromTitle;
  Q.doSearch = doSearch;
  Q.handleProductClick = handleProductClick;
  Q.showSearchDropdown = showSearchDropdown;
  Q.searchBackdrop = searchBackdrop;
  Q.maybeAddUOMLabel = maybeAddUOMLabel;
  Q.quoteTitle = quoteTitle;
  Q.defaultSubDescs = defaultSubDescs;
})();
